<template>
    <el-dialog v-model="dialog_opened" width="80%" :title="collection?collection.i18n_name.ZH_HANS:''">
        <h4>共{{ data.length }}张</h4>
        <el-table :data="data" v-loading="loading">
            <el-table-column label="ID" prop="image_id" width="150"></el-table-column>
            <el-table-column label="缩略图" prop="thumbnail" width="200">
              <template #default="scope">
                <el-image :src="`${$root.cdn_url}/${scope.row.thumbnail}`" lazy style="width: 180px"></el-image>
              </template>
            </el-table-column>
            <el-table-column label="模块" prop="module" width="100">
              <template #default="scope">
                {{ $root.image_module_enum[scope.row.module] }}
              </template>
            </el-table-column>
            <el-table-column label="操作">
                <template #default="scope">
                    <el-button type="success" circle icon="Top" :loading="loading" size="small"
                               :disabled="scope.$index===0" @click="moveUp(scope.$index)"></el-button>
                    <el-button type="success" circle icon="Bottom" :loading="loading" size="small"
                               :disabled="scope.$index===data.length - 1" @click="moveDown(scope.$index)"></el-button>
                    <el-button type="danger" :disabled="loading" @click="remove(scope.row)">从集合中删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-table :data="image_list" style="margin-top: 10px">
          <el-table-column label="预览图" prop="prefix" width="230">
            <template #default="scope">
              <el-image :src="`${$root.cdn_url}/${scope.row.thumbnail}`" lazy style="width: 180px"></el-image>
<!--              <el-image lazy :src="`${$root.cdn_url}/${scope.row.thumbnail}`"-->
<!--                        style="width: 100px"></el-image>-->
            </template>
          </el-table-column>
          <el-table-column label="id" prop="id" width="150"></el-table-column>
<!--          <el-table-column label="nick" prop="nickname" width="60"></el-table-column>-->
          <el-table-column label="模块" prop="module" width="100">
            <template #default="scope">
              {{ $root.image_module_enum[scope.row.module] }}
            </template>
          </el-table-column>
          <el-table-column label="平台" prop="platform" width="100">
          </el-table-column>
          <el-table-column label="分类" prop="categories" width="200">
            <template #default="scope">
              <template v-for="key in scope.row.categories">
                <template v-for="c in category_list">
                  <el-tag v-if="c.key === key">{{ c.i18n_name.EN }}</el-tag>
                </template>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="上线时间" prop="online_date" width="150">
            <template #default="scope">
              <el-date-picker style="width: 120px" value-format="YYYY-MM-DD" v-model="scope.row.online_date"
                              @change="update(scope.row)" :clearable="false"></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template #default="scope">
              <el-button type="primary" :disabled="scope.row.added"
                         @click="addToCollection(scope.row, scope.row.id)">
                {{ scope.row.added ? '已添加' : '添加到合集' }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px">
            <el-button type="primary" :loading="loading" @click="createImage">向集合中添加图片</el-button>
        </div>
    </el-dialog>
</template>

<script>
import axios from "ts-axios-new";
import {ElMessageBox, ElMessage} from 'element-plus'
import {timestampToDate} from "../libs/utils";
import {getProduct} from "../libs/app.ts";

export default {
    name: "CollectionImage",
    data() {
        return {
            loading: false, dialog_opened: false, data: [], collection: null, image_list: [], category_list: [],
        }
    },
    // inject: ['major_map', 'minor_map', 'assistant_map'],
    methods: {
        init(collection) {
            this.collection = collection;
            this.$nextTick(_ => {
                this.dialog_opened = this.loading = true;
                axios.all([
                    axios.get(`/cms/v1/collection/${collection.id}/image`).then(res => {
                        this.data = res.data.data.imageList;
                        // this.loading = false;
                    }),
                    axios.get(`/cms/v1/image?module=4`, {params: {product: getProduct().key}}).then(res => {
                      this.image_list = res.data.data.imageList;
                    }),
                    axios.get(`/cms/v1/category`).then(res => {
                      this.category_list = res.data.data.categoryList;
                })]).then(_ => {
                    this.loading = false;
                })
              })
        },
        remove(row) {
            ElMessageBox.confirm('确定要从集合中删除该图片吗？', '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning',
            }).then(_ => {
                this.loading = true;
                axios.delete(`/cms/v1/collection/${this.collection.id}/image`, {data: {image_id: row.image_id}}).then(res => {
                    this.data.splice(this.data.indexOf(row), 1);
                    this.loading = false;
                })
            }).catch(_ => {
            })
        },
        createImage() {
            ElMessageBox.prompt('请输入图片id', '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                inputPattern: /[a-z0-9]{24}/,
                inputErrorMessage: '请输入合法id',
            }).then(({value}) => {
              this.addToCollection(null, value)
            }).catch(_ => {})
        },
        timestampToDate(timestamp) {
          return timestampToDate(timestamp)
        },
        addToCollection(image, id) {
          this.loading = true;
          axios.post(`/cms/v1/collection/${this.collection.id}/image`, {image_id: id}).then(res => {
            if(image) {
              image.added = true
            }
            this.data.push(res.data.data);
            this.resort();
            this.loading = false;
          }).catch(err => {
            ElMessage.error(err.response.data.status.message);
            this.loading = false;
          })
        },
        update(row) {
          this.loading = true;
          axios.put(`/cms/v1/image/${row.id}`, row).then(_ => {
            this.loading = false;
          })
        },
        moveUp(index) {
            const row = this.data.splice(index, 1);
            this.data.splice(index - 1, 0, row[0]);
            this.resort();
        },
        moveDown(index) {
            const row = this.data.splice(index, 1);
            this.data.splice(index + 1, 0, row[0]);
            this.resort();
        },
        resort() {
            const sort = [];
            this.data.forEach(d => {
                sort.push(d.id);
            })
            axios.post(`/cms/v1/sort/collection/image`, {sort}).then(_ => {
            })
        },
    },
}
</script>

<style scoped>

</style>